import { render, staticRenderFns } from "./HabitRegisterDialog.vue?vue&type=template&id=f3b9b1c0&scoped=true"
import script from "./HabitRegisterDialog.vue?vue&type=script&lang=js"
export * from "./HabitRegisterDialog.vue?vue&type=script&lang=js"
import style0 from "./HabitRegisterDialog.vue?vue&type=style&index=0&id=f3b9b1c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b9b1c0",
  null
  
)

export default component.exports